import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';

import SdkCategoryTable from './SdkCategoryTable';
import Skeletons from '../Skeletons';

import { sdksSelector, sdksSettingsSelector } from '../../selectors';

const InstalledSdks = () => {
  const categories = useSelector(sdksSelector);
  const { loaded, pending } = useSelector(sdksSettingsSelector);

  const [openIndex, setOpenIndex] = useState({});

  if (pending || !loaded) {
    return (
      <section className="publisher_page_sdks b-t pt-xxl mb-xxl">
        <h2 className="text-md m-b">Installed SDKs</h2>
        <div className="sdk-list">
          {Skeletons.sdksPanel}
          {Skeletons.sdksPanel}
        </div>
      </section>
    );
  }

  if (!categories || categories.length === 0) {
    return (
      <section className="publisher_page_sdks b-t pt-xxl mb-xxl">
        <h2 className="text-md m-b">Installed SDKs</h2>
        <div className="sdk-list">
          <h3 className="text-bold text-sm text-center">SDK data not detected</h3>
        </div>
      </section>
    );
  }

  return (
    <section className="publisher_page_sdks b-t pt-xxl mb-xxl">
      <h2 className="text-md m-b">Installed SDKs</h2>
      <div className="sdk-list">
        {categories.map((category, index) => {
          const isOpen = openIndex[index] ?? index < 2;
          const label =
            category.function_label || SDK_FUNCTIONS[category.function_id] || 'Miscellaneous';

          return (
            <div key={category.function_id} className={cx('panel', !isOpen && 'in')}>
              <button
                type="button"
                className="panel-header bg-gray d-flex flex-items-xxs-middle b-t b-b text-sm w-100 btn-link p-y-xs"
                onClick={() => setOpenIndex((prev) => ({ ...prev, [index]: !isOpen }))}
              >
                <i className="p-l-xs p-r-xs text-muted transitionable hicon-angle-up" />
                <span>
                  {label} ({category.sdks.length})
                </span>
              </button>
              {isOpen && (
                <div className="panel-body pos-rel">
                  <SdkCategoryTable sdks={category.sdks} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default InstalledSdks;
